export default "/images/vendor/@coreui/icons/svg/flag/cif-il.svg?9cab6bb2fc0731fc3e9a91d2e046f2fa";